import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { apiSciScoreClient } from '@utils/api/base';
import { AppThunk } from '../store';
import { SubmissionL } from '../type';

export interface Submissions {
  errors: Array<string>;
  limit?: number;
  size?: number;
  start_after?: number;
  continues: boolean;
  data: SubmissionL[];
}

let initialState: Submissions = {
  errors: [],
  continues: false,
  data: [],
};

const submissionSlice = createSlice({
  name: "submissions",
  initialState: initialState,
  reducers: {
    addOne: (state, { payload }: PayloadAction<SubmissionL>) => {
      state.data.push(payload);
    },
    // addMany: (state, action: PayloadAction<Compound2[]>) => {
    //   state.data.push(...action.payload);
    // },
    replace: (state, action: PayloadAction<SubmissionL[]>) => {
      state.data = action.payload;
    },
    // update: (state, { payload }: PayloadAction<SubmissionL>) => {
    //   const cmpToUpdate = state.data.find((cmp) => cmp._id === payload._id);
    //   if (cmpToUpdate) {
    //     const { path, value } = payload;
    //     _.set(cmpToUpdate, path, value);
    //   }
    // },
  },
});

export const { addOne, replace } = submissionSlice.actions;

export default submissionSlice.reducer;

export const getSubmissions =
  (page: number = 0): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await apiSciScoreClient.get("/submission/");
      //console.log(data);
      dispatch(replace(data.data));
    } catch (err) {
      console.error("getSubmissions Failed: ", err);
    }
  };
